module.exports = __webpack_public_path__ + "static/img/question4-3.a50c6bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/question4-3.png
// module id = OWJa
// module chunks = 1